module.exports = "<div class=row> <div class=\"container-fluid animated fade-in\"> <div class=\"panel panel-default\"> <div class=panel-body> <form role=form name=keywordForm id=keywordForm ng-submit=submit() novalidate> <div class=form-group> <label for=name>Nome</label> <input type=text class=form-control id=name placeholder=Nome ng-model=keywordForm.comment.comment /> </div> <div buttonmodalform></div> </form> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/keyword/keywordDetail/keywordDetail.html
// module id = 59
// module chunks = 0